import { render, staticRenderFns } from "./RatingModal.vue?vue&type=template&id=5ef01b62&"
import script from "./RatingModal.vue?vue&type=script&lang=js&"
export * from "./RatingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports